import { IonButton, IonSpinner } from "@ionic/react";
import { Shift } from "@src/lib/interface/src";

import { NegotiationActionButton } from "./NegotiationActionButton";
import {
  NegotiationCommitType,
  NegotiationRateRole,
  NegotiationStatus,
  RateNegotiationHistoryResponse,
} from "../interfaces";

interface Props {
  shift: Shift;
  negotiationHistory: RateNegotiationHistoryResponse[];
  isWorkerProposing: boolean;
  showCommitModal: (_: any) => void;
  loadAlertDialog: (callback?: () => void) => void;
  pageLoading: boolean;
  isLoadingShiftBook?: boolean;
  proposeButtonText: string;
  handleEndNegotiation: () => Promise<void>;
  onClickProposeButton: () => void;
}

export function ProposeNewInfoButtons(props: Props) {
  const {
    onClickProposeButton,
    shift,
    negotiationHistory,
    isWorkerProposing,
    showCommitModal,
    pageLoading,
    isLoadingShiftBook,
    proposeButtonText,
    handleEndNegotiation,
  } = props;
  const negotiationIsBookable = negotiationHistory.some((historyItem) => {
    return historyItem.createdByUserRole === NegotiationRateRole.WORKPLACE;
  });
  return (
    <>
      {(isWorkerProposing || negotiationIsBookable) && (
        <IonButton
          expand="full"
          shape="round"
          className={`propose-rate-button ${!isWorkerProposing ? "lower-limit" : ""}`}
          fill={isWorkerProposing ? "outline" : "solid"}
          id="negotiation-commit-btn"
          onClick={() => {
            onClickProposeButton();
          }}
        >
          {pageLoading || isLoadingShiftBook ? (
            <div className="network-loading">
              <IonSpinner />
            </div>
          ) : (
            proposeButtonText
          )}
        </IonButton>
      )}
      {shift?.rateNegotiation?.status === NegotiationStatus.OPEN && (
        <NegotiationActionButton
          className="end-negotiation-button"
          onClick={() => {
            showCommitModal({
              isOpen: true,
              onCommit: handleEndNegotiation,
              modalType: NegotiationCommitType.END_NEGOTIATION,
            });
          }}
        >
          End Negotiation
        </NegotiationActionButton>
      )}
    </>
  );
}
